/**
 * Links the three "bouw" pages together so title, route and image can never
 * drift apart: the router derives its `meta.micrioId` from here and the door
 * transition reads the same config. The keys of PAGES are also the Micrio embed
 * button titles.
 */
import doorBovenbouw from '@/assets/images/door-bovenbouw.webp'
import doorMiddenbouw from '@/assets/images/door-middenbouw.webp'
import doorOnderbouw from '@/assets/images/door-onderbouw.webp'
import previewBovenbouw from '@/assets/images/preview-bovenbouw.webp'

/** Which side the door's handle — and therefore its opening edge — sits on. */
export type HandleSide = 'left' | 'right'

export interface PageConfig {
	route: string
	micrioId: string
	/**
	 * Drives both the swing direction and the zoom anchor. Must match the side the
	 * handle is drawn on in `leafImage`.
	 */
	handleSide: HandleSide
	/** The door leaf artwork — leaf only, with its own handle, no frame. */
	leafImage: string
	/**
	 * The still shown through the doorway during the transition. Without one, the
	 * doorway falls back to Micrio's own base tile for this image, which tracks
	 * dashboard edits but is only one tile and so fairly soft.
	 */
	previewImage?: string
}

/** The overview image that holds the embed buttons. */
export const HOME_MICRIO_ID = 'ToGWUxO'

export const PAGES: Record<string, PageConfig> = {
	onderbouw: { route: 'onderbouw', micrioId: 'mRVnUon', handleSide: 'left', leafImage: doorOnderbouw },
	middenbouw: { route: 'middenbouw', micrioId: 'aoGUsWh', handleSide: 'right', leafImage: doorMiddenbouw },
	bovenbouw: {
		route: 'bovenbouw',
		micrioId: 'YMdMHNo',
		handleSide: 'left',
		leafImage: doorBovenbouw,
		previewImage: previewBovenbouw,
	},
}

/** Case- and whitespace-tolerant, since the title comes from Micrio's data. */
export function pageByTitle(title: string): PageConfig | undefined {
	return PAGES[title.trim().toLowerCase()]
}
